import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

import { LeafletProvider, addClassName, useLeafletContext } from '@react-leaflet/core';
import React, { useState, useEffect, useMemo } from 'react';
import { createPortal } from 'react-dom';
var DEFAULT_PANES = ['mapPane', 'markerPane', 'overlayPane', 'popupPane', 'shadowPane', 'tilePane', 'tooltipPane'];

function omitPane(obj, pane) {
  var _p = obj[pane],
      others = _objectWithoutProperties(obj, [pane].map(_toPropertyKey));

  return others;
}

function createPane(props, context) {
  var _props$pane;

  var name = props.name;

  if (DEFAULT_PANES.indexOf(name) !== -1) {
    throw new Error("You must use a unique name for a pane that is not a default Leaflet pane: ".concat(name));
  }

  if (context.map.getPane(name) != null) {
    throw new Error("A pane with this name already exists: ".concat(name));
  }

  var parentPaneName = (_props$pane = props.pane) !== null && _props$pane !== void 0 ? _props$pane : context.pane;
  var parentPane = parentPaneName ? context.map.getPane(parentPaneName) : undefined;
  var element = context.map.createPane(name, parentPane);

  if (props.className != null) {
    addClassName(element, props.className);
  }

  if (props.style != null) {
    Object.keys(props.style).forEach(function (key) {
      // @ts-ignore
      element.style[key] = props.style[key];
    });
  }

  return element;
}

export function Pane(props) {
  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      paneElement = _useState2[0],
      setPaneElement = _useState2[1];

  var context = useLeafletContext();
  var newContext = useMemo(function () {
    return _objectSpread(_objectSpread({}, context), {}, {
      pane: props.name
    });
  }, [context]);
  useEffect(function () {
    setPaneElement(createPane(props, context));
    return function removeCreatedPane() {
      var pane = context.map.getPane(props.name);
      pane == null ? void 0 : pane.remove == null ? void 0 : pane.remove(); // @ts-ignore map internals

      if (context.map._panes != null) {
        // @ts-ignore map internals
        context.map._panes = omitPane(context.map._panes, props.name); // @ts-ignore map internals

        context.map._paneRenderers = omitPane( // @ts-ignore map internals
        context.map._paneRenderers, props.name);
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return props.children != null && paneElement != null ? /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(LeafletProvider, {
    value: newContext
  }, props.children), paneElement) : null;
}